import "./App.css";
import Header from "./Components/Header";
import RouteComponent from "./Router/router";
import Footer from "./Components/Footer";
import ScrollToTop from "./scrolltotop";

function App() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <RouteComponent />
      <Footer />
    </>
  );
}

export default App;
